exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Pompiere&display=swap);", ""]);

// module
exports.push([module.id, ".bannerFont{font-family:Abril Fatface,sans-serif;font-weight:bolder;font-size:55px!important;line-height:1}.bannerBodyFont{font-family:Pompiere,cursive;font-size:30px!important;line-height:1}.iconosBanner{font-size:36px!important}.Carousel{height:100vh!important;position:relative!important;margin:0!important}.display-dark{background:#000;position:absolute;opacity:.4;width:100%;height:100vh;top:0;z-index:1}.darker:before{content:\"\";position:absolute;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,.7)}.brigther{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-530d7f44","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Banner.vue
// module id = 469
// module chunks = 2